
























































import {Component, Prop, Vue} from 'vue-property-decorator'
import IconRow from "@/components/IconRow.vue";

@Component({
    components: {IconRow}
})
export default class Project extends Vue
{
    @Prop({required: true}) readonly data!: ProjectData
    @Prop({required: true}) readonly index!: number
}

export interface ProjectData
{
    title: string;
    desc: string;
    links: { name: string; link: string }[];
    images: string[];
    icons: string[][];
}
